import { z } from "zod";

function hasSecretOrHiddenText(text: string): boolean {
  if (
    text.includes(String.fromCodePoint(0)) ||
    /[\u200b-\u200d\ufeff\u202a-\u202e\u2066-\u2069]/u.test(text)
  )
    return true;
  const patterns = [
    /-----BEGIN [A-Z ]*PRIVATE KEY-----/,
    /\b(sk-[A-Za-z0-9_-]{20,}|sk_live_[A-Za-z0-9]{16,})/,
    /\b(gh[pousr]_[A-Za-z0-9]{30,}|github_pat_[A-Za-z0-9_]{20,})/,
    /\bxox[abprs]-[A-Za-z0-9-]{10,}/,
    /\bAKIA[0-9A-Z]{16}\b/,
    /\bAIza[0-9A-Za-z_-]{35}\b/,
    /[a-z][a-z0-9+.-]*:\/\/[^\s/:@]+:[^\s/@]+@/i,
    /\b[0-9a-f]{32,}\b/i,
  ];
  if (patterns.some((pattern) => pattern.test(text))) return true;
  return (text.match(/[A-Za-z0-9+_=]{32,}/g) ?? []).some(
    (run) =>
      (/[a-z]/.test(run) && /[A-Z]/.test(run) && /[0-9]/.test(run)) ||
      (run.length >= 40 && /[A-Za-z]/.test(run) && /[0-9]/.test(run)),
  );
}

/** Organization-authored catalog definitions contain prose only, never code or credentials. */
export const orgBotInputSchema = z
  .object({
    name: z.string().trim().min(1).max(40),
    title: z.string().trim().min(1).max(60),
    category: z.enum([
      "meetings",
      "email",
      "delivery",
      "contracts",
      "sales",
      "finance",
      "people",
      "research",
      "personal",
    ]),
    description: z.string().trim().min(1).max(300),
    instructions: z.string().trim().min(1).max(8000),
    boundaries: z.string().trim().min(1).max(600),
  })
  .strict()
  .superRefine((value, ctx) => {
    for (const [key, text] of Object.entries(value)) {
      if (hasSecretOrHiddenText(text)) {
        ctx.addIssue({
          code: "custom",
          path: [key],
          message: "Remove credentials or hidden directional characters.",
        });
      }
    }
  });
export type OrgBotInput = z.infer<typeof orgBotInputSchema>;
export type OrgBot = OrgBotInput & { id: string; createdAt: string };
